import { createPersistentStorage } from "@/script/storage/storage-factory"

export default createPersistentStorage(
	"tcf.filters",
	{
		// Points of Interest
		namedLocation: true,
		deadDrop: true,
		keyDoor: true,
		healPlant: true,
		uplink: true,
		staticQuest: true,
		caveEntrance: false,
		lostProspector: false,

		// Supplies
		hiddenBarrel: false,
		weaponCrate: false,
		grenadeCrate: false,
		ammoCrate: false,
		medCase: false,

		// Loot
		safe: false,
		locker: false,
		jacket: false,
		luggage: false,
		briefcase: false,
		storageBox: false,
		minersCrate: false,
		filingCabinet: false,

		// Spawn & Evac
		spawn: false,
		evac: false,

		// Random Encounters
		meteor: false,
		egg: false,

		// Minerals
		focusCrystal: false,
		veltecite: false,
		nickel: false,
		titan: false,

		// Flora & Fungi
		waterweed: false,
		mushroom: false,
		dustBloom: false,
		ivyBlossom: false,

		// Fauna
		marauder: false,
		crusher: false,
	},
	{},
	{},
	{}
)
